module.exports = __webpack_public_path__ + "img/HamochiResult1.fd4fb54d.png";